import React, { useState, useEffect, useRef } from 'react';
import global from "../../global-variables";
import { Link, useLocation,useNavigate} from "react-router-dom";
import { FiSearch } from "react-icons/fi";
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Offcanvas from 'react-bootstrap/Offcanvas';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import axios from 'axios';
import globalVariables from '../../global-variables';
import WOW from 'wowjs';
import { Container, Row, Col } from 'reactstrap';
import { HashLink } from "react-router-hash-link";
import $ from "jquery";
import TrackingCode from '../../hooks/TrackingCode.js';

export const scrollToTop = () => {
    window.scrollTo({
    top: 0,
    behavior: 'smooth' // Optional smooth scrolling
    });
};

export default function Header(props) {

    const ref = useRef(null);
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [fullscreen, setFullscreen] = useState(true);
    //const pathname = useLocation();

    const [newsletteryear, setNewsLetterYearList] = useState(null);

    const navigate = useNavigate();
    //navbar active 
    const location = useLocation();
    const { pathname } = location;
    const splitLocation = pathname.split("/");
    
    //navbar active 
    

    const scrollWithOffset = (el) => {
        const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset;
        const yOffset = -134;
        window.scrollTo({ top: yCoordinate + yOffset, behavior: 'smooth' });
    }

    useEffect(() => {
        // Go to Top OR Scroll to top
        document.documentElement.scrollTo({
            top: 0,
            left: 0,
            behavior: "instant", // Optional if you want to skip the scrolling animation (comment behavior if u want to animate)
        });
    }, [pathname]);

    useEffect(() => {
        // initiate the wow effect
        new WOW.WOW({
            live: false
        }).init();


        $(document).ready(function () {
            $('div#offcanvas-overlay').on('click', function () {
                $('html').removeClass('open-menu');
            });
        });

    }, []);

     //serach  function
     function url_generator(url) {
        var url_generated = "";
        // For local host
        if (window.location.href.indexOf('localhost') != -1) {
            url_generated = url;
        }

        //    // For my machine Server
        else if (window.location.href.indexOf('192.168.2.202') != -1) {
            // url_generated = "/a/amnsinternationalschool" + url;
            url_generated = url;
        }

        // For Live server
        else {
            url_generated = url;
        }
        // alert(url_generated);
        return url_generated;
    }

    useEffect(() => {

        $("#btnsearchSite").on("click", function (e) {

            $("#searchSiteerr").html("");
            if ($("#txtSearchSite").val() == "") {
                $("#searchSiteerr").html("Please Enter Search String");
                return;
            }
            else {
                window.location.href = (global.variables.strDomainUrl + "search-results/" + $("#txtSearchSite").val());
            }

            
        });


        $('#txtSearchSite').keypress(function (e) {
            var key = e.which;
            if (key == 13)  // the enter key code
            {
                if ($("#txtSearchSite").val() == "") {
                    $("#searchSiteerr").html("Please Enter Search String");
                    return;
                }
                else {
                    <Link to=""></Link>
                    window.location.href = url_generator(global.variables.strDomainUrl + "search-results/" + $("#txtSearchSite").val());
                }
                return false;
            }
        });

        $('#focusOnInput').on('click', function () {
            setTimeout(() => {
                ref.current.focus();

            }, 500);
        })

    })

    const [peopleCategory, setPeopleCategoryList] = useState([]);

    useEffect(() => {
        let _obj = new Object();
        _obj.pcategory_status = 1;
        setTimeout(() => {

            axios.post(global.variables.strApiUrl + "/peoplecategoryApi/getcategoryHavingPeopleList", _obj)
                .then((response_list) => {
                    if(response_list.data === 'error')
                    {
                        navigate('/error-page')
                    }
                    else
                    {
                        // pass the result in the success function of the respective page
                        setPeopleCategoryList(response_list.data[0]);
                    }
                });
        }, 300);

        //make the object for getting the report year list
        let _objNLetterYear = new Object();
        _objNLetterYear.nletter_status = 1;

        //Get news type yesr List
        axios.post(globalVariables.variables.strApiUrl + "/nletterApi/getnletterdistinctyear", _objNLetterYear)
            .then((response_list) => {

                if (response_list.data === "error") {
                    navigate("/error-page")
                }
                else {
                    // pass the result in the success function of the respective page
                    setNewsLetterYearList(response_list.data[0][0]?.nletter_year);

                }

            });

    }, [])

    const [diseaseCategory, setDiseaseCategoryList] = useState([]);
    

    useEffect(() => {
        let _obj = new Object();
        _obj.disease_cat_status = 1;
        setTimeout(() => {

            axios.post(global.variables.strApiUrl + "/diseasecategoryApi/getcategoryHavingDiseaseList", _obj)
                .then((response_list) => {
                    if(response_list.data === 'error')
                    {
                        navigate('/error-page')
                    }
                    else
                    {
                    // pass the result in the success function of the respective page
                    setDiseaseCategoryList(response_list.data[0]);
                    }
                });
        }, 300);

    }, [])
    
    const [disease, setDiseaseList] = useState([]);

    useEffect(() => {
        let _obj = new Object();
        _obj.disease_status = 1;
        setTimeout(() => {

            axios.post(global.variables.strApiUrl + "/diseaseApi/getdiseaseList", _obj)
                .then((response_list) => {
                    if(response_list.data === 'error')
                    {
                        navigate('/error-page')
                    }
                    else
                    {
                    // pass the result in the success function of the respective page
                    setDiseaseList(response_list.data[0]);
                    }
                });
        }, 300);

    }, [])

    let conversion_code = "";

    if(props.conversion_code != undefined)
    {
        conversion_code = 1;
    }
    else
    {
       conversion_code = 2; 
    }

    return (
        <>
            <Navbar className={props.main_className + " fixed-top bg-white"} expand="xl">
                <Container fluid className='px-0'>
                    <Container fluid="xxl">
                        <div className="d-flex align-items-lg-stretch align-items-center justify-content-lg-between">
                            <div className='pe-0 col-8 col-md-6 col-lg-6 col-xl-5'>
                                <div className='logo my-3'>
                                    <Link to="/" className="position-relative overflow-hidden" onClick={scrollToTop}>
                                        <img src={global.variables.strDomainUrl + "images/logo.png"} className="img-fluid animated fadeIn my-0 p-0 me-4" width="221" height="85" alt="National Disease Modelling Consortium - NDMC" title="National Disease Modelling Consortium - NDMC" />
                                        <img src={global.variables.strDomainUrl + "images/iitb-logo.png"} className="img-fluid animated fadeIn" width="88" height="85" alt="Indian Institute of Technology Bombay" title="Indian Institute of Technology Bombay" />
                                    </Link>
                                </div>
                            </div>
                            <div className='ps-xl-5 col-4 col-md-6 col-lg-6 col-xl-7'>
                            <div className="d-flex justify-content-end align-items-center mb-xl-2 pb-xl-1">
                            <div className="me-3">
                                        <Link className="bg-transparent nav-link icon-search animated fadeInUp" id='focusOnInput' onClick={handleShow}><FiSearch /></Link>
                                </div>
                                <div>
                                    <ul className="navbar-nav fw-normal top-nav m-0">
                                    {/* <li className="nav-item d-xl-block d-none">
                                    <Link to="/joinus" onClick={scrollToTop} className="nav-link animated fadeInUp">Join Us</Link>
                                    </li> */}
                                    {/* <li className="nav-item d-xl-block d-none">
                                    <Link to="/blog" onClick={scrollToTop} className="nav-link animated fadeInUp">Blog</Link>
                                    </li> */}
                                    <li className="nav-item d-xl-block d-none">
                                    <Link to="/contactus" onClick={scrollToTop} className="nav-link animated fadeInUp">Contact Us</Link>
                                    </li>
                                    </ul>
                                </div>
                                

                                <Navbar.Toggle className="offcanvas-toggle shadow-none px-1 animated fadeIn" aria-controls={'offcanvas-menu'}>
                                    <span className="icon-bar"></span>
                                    <span className="icon-bar"></span>
                                    <span className="icon-bar"></span>
                                </Navbar.Toggle>
                                </div>
                                <Navbar.Offcanvas id={'offcanvas-menu'} aria-labelledby={'offcanvas-menu'} placement="end" responsive="xl" className="px-0">
                                    <Offcanvas.Header closeButton>
                                        <Offcanvas.Title>
                                        </Offcanvas.Title>
                                    </Offcanvas.Header>
                                    <ul className="navbar-nav mt-xl-auto justify-content-between hdr-nav">
                                        <li className={splitLocation[1] === "aboutus" ? "active" : "" || splitLocation[1] === "milestone" ? "active" : ""}>
                                            <NavDropdown title="About Us" id="basic-nav-dropdown" className="animated fadeIn" renderMenuOnMount={true}>
                                                <ul className='hdr-dd-menu p-0'>
                                                    <NavDropdown.Item as="li"><Link to="/aboutus" onClick={scrollToTop}>Introduction</Link></NavDropdown.Item>
                                                    <NavDropdown.Item as="li"><HashLink to="/aboutus#objectives" scroll={el => scrollWithOffset(el)}>Objectives</HashLink></NavDropdown.Item>
                                                    <NavDropdown.Item as="li"><HashLink to="/aboutus#whyiitb" scroll={el => scrollWithOffset(el)}>Why IITB</HashLink></NavDropdown.Item>
                                                    <NavDropdown.Item as="li"><Link to="/milestone" onClick={scrollToTop}>Milestones</Link></NavDropdown.Item>
                                                </ul>
                                            </NavDropdown>
                                        </li>
                                        <li className={splitLocation[1] === "people" ? "active" : ""}>
                                            <NavDropdown title="People" id="basic-nav-dropdown" className="animated fadeIn" renderMenuOnMount={true}>
                                                <ul className='hdr-dd-menu p-0'>
                                                    {
                                                        peopleCategory.map((val_people) => {
                                                            return (

                                                                <NavDropdown.Item as="li"><Link to={globalVariables.variables.strDomainUrl + "people/" + val_people.pcategory_pagename} onClick={scrollToTop}>{val_people.pcategory_name}</Link></NavDropdown.Item>
                                                            )
                                                        })
                                                    }

                                                </ul>
                                            </NavDropdown>
                                        </li>
                                        <li className={splitLocation[1] === "disease" ? "active" : ""}>
                                            <NavDropdown title="Diseases" id="basic-nav-dropdown" className="animated fadeIn" renderMenuOnMount={true}>
                                                <ul className='hdr-dd-menu p-0'>
                                                    {
                                                        diseaseCategory.map((val)=>{
                                                            
                                                            return(
                                                                <>
                                                             
                                                                    {
                                                                            // if disease diff is same then show text else link 
                                                                        val.disease_diff_name != null &&  val.disease_diff_name != "null"? 
                                                                        <NavDropdown.Item as="li" className='dropdown-header'>{val.disease_cat_name}</NavDropdown.Item> 
                                                                        : 
                                                                        <NavDropdown.Item as="li"><Link to={global.variables.strDomainUrl + "disease/" + val.disease_pagename} onClick={scrollToTop}>{val.disease_cat_name}</Link></NavDropdown.Item>
                                                                                    
                                                                    }
                                                                   {
                                                                    disease.map((val_disease)=>{
                                                                        return(
                                                                            <>
                                                                            
                                                                                {
                                                                                    // if disease count is greater than one and categroy id equal to disease_disease_cat_id
                                                                                    val.disease_count > 1  && val.disease_cat_id === val_disease.disease_disease_cat_id ? 
                                                                                    <NavDropdown.Item as="li"><Link to={global.variables.strDomainUrl + "disease/" + val_disease.disease_pagename} onClick={scrollToTop} className='fw-normal ms-2'>- {val_disease.disease_name}</Link></NavDropdown.Item> 
                                                                                    : 
                                                                                        null
                                                                                }

                                                                                {
                                                                                    // if disease count is equal and disease_cat_name not equal to disease_name
                                                                                    val.disease_count === 1 && val.disease_cat_name != val_disease.disease_name  && val.disease_cat_id === val_disease.disease_disease_cat_id ? 
                                                                                    <NavDropdown.Item as="li"><Link to={global.variables.strDomainUrl + "disease/" + val_disease.disease_pagename} onClick={scrollToTop} className='fw-normal ms-2'>- {val_disease.disease_name}</Link></NavDropdown.Item> 
                                                                                    : 
                                                                                        null
                                                                                }

                                                                            </>
                                                                        
                                                                               
                                                                        )
                                                                        
                                                                    })
                                                                   }
                                                            </>     
                                                            )
                                                        })
                                                    }
                                                    
                                                </ul>
                                            </NavDropdown>
                                        </li>
                                        <li className={splitLocation[1] === "events" ? "active" : "" || splitLocation[1] === "news" ? "active" : "" || splitLocation[1] === "newsletter" ? "active" : ""}>
                                            <NavDropdown title="News & Events" id="basic-nav-dropdown" className="animated fadeIn" renderMenuOnMount={true}>
                                                <ul className='hdr-dd-menu p-0'>
                                                    <NavDropdown.Item as="li"><Link to="/events" onClick={scrollToTop}>Events/Workshops</Link></NavDropdown.Item>
                                                    <NavDropdown.Item as="li"><Link to="/news" onClick={scrollToTop}>News</Link></NavDropdown.Item>
                                                    <NavDropdown.Item as="li"><Link to={newsletteryear != null ? "/newsletter/" + newsletteryear : "/newsletter/" + new Date().getFullYear()} onClick={scrollToTop}>Newsletter</Link></NavDropdown.Item>
                                                </ul>
                                            </NavDropdown>
                                        </li>
                                        <li className={splitLocation[1] === "publications" ? "active nav-item animated fadeIn" : "nav-item animated fadeIn"}><Link to="/publications" className="nav-link" onClick={scrollToTop}>Publications</Link></li>
                                        <li className={splitLocation[1] === "resources" ? "active nav-item animated fadeIn" : "nav-item animated fadeIn"}><Link to="/resources" className="nav-link" onClick={scrollToTop}>Resources</Link></li>
                                        {/* <li className="nav-item animated fadeInUp"><HashLink to="#contact" className="nav-link" scroll={el => scrollWithOffset(el)}>Contact Us</HashLink></li> */}
                                       
                                        {/* <li className={splitLocation[1] === "joinus" ? "active nav-item d-xl-none animated fadeIn" : "nav-item animated d-xl-none fadeIn"}><Link to="/joinus" className="nav-link" onClick={scrollToTop}>Join Us</Link></li> */}

                                        {/* <li className={`${splitLocation[1] === "blog" ? "active" : "" || splitLocation[1] === "blog-details" ? "active" : "" || splitLocation[1] === "blog-category" ? "active" : "" || splitLocation[1] === "blog-authors" ? "active" : "" || splitLocation[1] === "blog-tags" ? "active" : ""} d-xl-none`}><Link to="/blog" className="nav-link animated fadeIn" onClick={scrollToTop}>Blog</Link></li> */}
                                        
                                        <li className={splitLocation[1] === "contactus" ? "active nav-item d-xl-none animated fadeIn" : "nav-item animated d-xl-none fadeIn"}><Link to="/contactus" className="nav-link" onClick={scrollToTop}>Contact Us</Link></li>
                                        
                                    </ul>
                                </Navbar.Offcanvas>
                            </div>
                        </div>
                    </Container>
                </Container>
                <Modal show={show} fullscreen={fullscreen} onHide={handleClose} className="bg-search-panel">
                    <Modal.Header closeButton className="border-0 p-md-5 p-4 h5">
                        <Modal.Title></Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="d-flex justify-content-center">
                        <Container>
                            <div className="col-md-8 mx-auto">
                                <InputGroup className="mb-3 border rounded bg-white">
                                    <Form.Control
                                        className="border-0 form-control-lg shadow-none"
                                        placeholder="Search"
                                        aria-label="Search"
                                        aria-describedby=""
                                        required=""
                                        id='txtSearchSite'
                                        ref={ref}
                                    />
                                    <span id="searchSiteerr" class="text-danger me-2" style={{ 'margin-top': ' 10px', 'margin-right': '5px' }}></span>
                                    <Button variant="outline-dark border-0" id="btnsearchSite">
                                        <FiSearch />
                                    </Button>
                                </InputGroup>
                            </div>
                        </Container>
                    </Modal.Body>
                </Modal>
            </Navbar>
            <TrackingCode conversion_code = {conversion_code}/>
        </>
    )
} 